// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5021":"css/admin-app.6856","9263":"css/app.6856"}[chunkId] + ".css";
};